import { useState, useEffect } from 'react';
import React from 'react';

// Constants
const INACTIVITY_TIMEOUT = 10 * 60 * 1000; // 10 minutes in milliseconds
const WARNING_BEFORE_TIMEOUT = 60 * 1000; // 1 minute in milliseconds

// Check if token exists (canonical key is `token`; `authToken` is legacy)
export const checkAuthToken = () => {
    const token = localStorage.getItem('token') || localStorage.getItem('authToken');
    return Boolean(token);
};

// Custom hook for session timeout
export const useSessionTimeout = (onTimeout, onWarning) => {
    const [lastActivity, setLastActivity] = useState(Date.now());
    const [showingWarning, setShowingWarning] = useState(false);

    const resetTimer = () => {
        setLastActivity(Date.now());
        setShowingWarning(false);
    };

    useEffect(() => {
        const handleActivity = () => {
            resetTimer();
        };

        // Add event listeners for user activity
        const events = ['mousedown', 'keydown', 'touchstart', 'mousemove'];
        events.forEach(event => {
            document.addEventListener(event, handleActivity);
        });

        // Timer to check for inactivity
        const checkInactivity = setInterval(() => {
            const timeSinceLastActivity = Date.now() - lastActivity;

            if (timeSinceLastActivity >= INACTIVITY_TIMEOUT) {
                // Time to logout
                clearInterval(checkInactivity);
                onTimeout();
            } else if (
                timeSinceLastActivity >= (INACTIVITY_TIMEOUT - WARNING_BEFORE_TIMEOUT) &&
                !showingWarning
            ) {
                // Show warning
                setShowingWarning(true);
                onWarning();
            }
        }, 1000); // Check every second

        return () => {
            // Cleanup
            events.forEach(event => {
                document.removeEventListener(event, handleActivity);
            });
            clearInterval(checkInactivity);
        };
    }, [lastActivity, showingWarning, onTimeout, onWarning]);

    return resetTimer;
};

// Notification component for session timeout warning
export const SessionTimeoutWarning = ({ onStayLoggedIn, onLogout }) => {
    return (
        <React.Fragment>
            <p>Your session will expire in 1 minute due to inactivity.</p>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                <button onClick={onStayLoggedIn} style={{ marginRight: '10px' }}>Stay Logged In</button>
                <button onClick={onLogout}>Logout Now</button>
            </div>
        </React.Fragment>
    );
}; 